module.exports = __webpack_public_path__ + "img/gc_country_flag_sk.1e706b66.svg";